import React from 'react';
import { Phone, Mail, Facebook, Instagram, Linkedin, Home, Users, Package, Briefcase, Book, Download, PhoneCall, Building2, MapPinHouse } from 'lucide-react';
import { Link } from 'react-router-dom';
import nutraLogo1 from "../../assets/Images/nfpl_logo.png";


export default function Footer() {
  const quickLinks = [
    { name: 'Home', icon: Home, href: '/' },
    { name: 'About Us', icon: Users, href: '/about-us' },
    { name: 'Products', icon: Package, href: '/products' },
    { name: 'Career', icon: Briefcase, href: '/career' },
    { name: 'Blog', icon: Book, href: '/blog' },
    { name: 'Download', icon: Download, href: '/download' },
    { name: 'Contact Us', icon: PhoneCall, href: '/contact-us' },
  ];

  const products = [
    { name: 'Effervescent Tablets', href: '/products/effervescenttablets' },
    { name: 'Chewable Tablet', href: '/products/chewabletablet' },
    { name: 'Tablets', href: '/products/tablets' },
    { name: 'Capsules', href: '/products/capsules' },
    { name: 'Powders', href: '/products/powders' },
    { name: 'Sachet', href: '/products/sachets' },
    { name: 'Mouth Dissolving Sachet', href: '/products/mouthdissolvingsachets' },
  ];

  const socialLinks = [
    { name: 'Facebook', icon: Facebook, href: 'https://facebook.com/nutralike' },
    { name: 'Instagram', icon: Instagram, href: 'https://instagram.com/nutralike' },
    { name: 'LinkedIn', icon: Linkedin, href: 'https://linkedin.com/company/nutralike' },
  ];

  const contactDepartments = [
    {
      title: 'Sales Department',
      items: [
        { icon: Phone, value: '+91 78628 91281', href: 'tel:+91 7862891281' },
        { icon: Phone, value: '+91 90164 12992', href: 'tel:+91 9016412992' },
        { icon: Mail, value: 'bd@nutralike.com', href: 'mailto:bd@nutralike.com' },
        { icon: Mail, value: 'marketing2@nutralike.com', href: 'mailto:marketing2@nutralike.com' },
        { icon: Mail, value: 'info@nutralike.com', href: 'mailto:info@nutralike.com' },
        
      ],
    },
  ];

  return (
    <footer className="bg-[#355931] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Logo Section */}
        <div className="pt-8 pb-6 flex justify-center border-b border-white border-opacity-20">
          <div className="text-center">
            <div className="flex items-center justify-center mb-2">
              <a href="/">
              <div className="shine">
                <img
                  src={nutraLogo1}
                  alt="Nutralike Logo"
                  className="w-[100px] h-[100px] object-contain filter brightness-0 invert hover:opacity-110 transition-opacity duration-200"
                />
                 </div>
              </a>
             
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="py-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
            
            {/* Left Section - Description & Contact */}
            <div className="col-span-1 sm:col-span-2 lg:col-span-1">
              <p className="text-base leading-relaxed mb-8 text-white text-opacity-90">
                Ready to Build Your Next Health Product? From concept to creation, Nutralike is here to support your growth. Reach out today and let's get started.
              </p>
              
              {/* Contact Us */}
              <div>
                <h3 className="text-lg font-bold mb-6 uppercase tracking-wide">Contact Us</h3>
                <div className="space-y-6">
                  {contactDepartments.map((dept) => (
                    <div key={dept.title}>
                      <h4 className="text-xs sm:text-sm font-semibold uppercase tracking-[0.18em] text-white text-opacity-80 mb-3 pb-1 border-b border-white border-opacity-20">
                        {dept.title}
                      </h4>
                      <div className="space-y-3">
                        {dept.items.map((item, idx) => (
                          <a
                            key={idx}
                            href={item.href}
                            className="flex items-center gap-3 group transition-all duration-200"
                          >
                            <div className="w-10 h-10 rounded-full border-2 border-white flex items-center justify-center flex-shrink-0 transition-all duration-200 group-hover:bg-white group-hover:scale-110">
                              <item.icon className="w-5 h-5 transition-colors duration-200 group-hover:text-[#355931]" />
                            </div>
                            <span className="text-sm sm:text-base transition-colors duration-200 group-hover:text-white break-all">
                              {item.value}
                            </span>
                          </a>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-bold mb-6 uppercase tracking-wide">Quick Links</h3>
              <ul className="space-y-3">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.href} 
                      className="text-base text-white text-opacity-90 hover:text-white hover:underline transition-colors duration-200 flex items-center gap-2 group"
                    >
                      <link.icon className="w-4 h-4 group-hover:scale-110 transition-transform duration-200" />
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Products */}
            <div>
              <h3 className="text-lg font-bold mb-6 uppercase tracking-wide">Products</h3>
              <ul className="space-y-3">
                {products.map((product) => (
                  <li key={product.name}>
                    <a 
                      href={product.href} 
                      className="text-base text-white text-opacity-90 hover:text-white hover:underline transition-colors duration-200"
                    >
                      {product.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Address Section */}
            <div className="col-span-1 sm:col-span-2 lg:col-span-1">
              {/* Office Address */}
              <div className="mb-8">
                <h3 className="text-lg font-bold mb-6 uppercase tracking-wide">Office Address</h3>
                <a 
                  href="https://maps.google.com/?q=410-11-12+Maibar+Prime+Nikol+Ahmedabad"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex gap-3 group transition-all duration-200"
                >
                  <div className="w-10 h-10 rounded-full border-2 border-white flex items-center justify-center flex-shrink-0 mt-1 transition-all duration-200 group-hover:bg-white group-hover:scale-110">
                    <Building2 className="w-5 h-5 transition-colors duration-200 group-hover:text-[#355931]" />
                  </div>
                  <p className="text-sm sm:text-base leading-relaxed text-white text-opacity-90 transition-all duration-200 group-hover:text-white">
                    410-11-12, Malbar Prime, Near Bhakti Circle, Nikol-382350, Ahmedabad, Gujarat, India.
                  </p>
                </a>
              </div>

              {/* Factory Address */}
              <div>
                <h3 className="text-lg font-bold mb-6 uppercase tracking-wide">Factory Address</h3>
                <a 
                  href="https://maps.google.com/?q=Survey+no.+1582+Swagat-3+Industrial+Park+Kuha+Ahmedabad"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex gap-3 group transition-all duration-200"
                >
                  <div className="w-10 h-10 rounded-full border-2 border-white flex items-center justify-center flex-shrink-0 mt-1 transition-all duration-200 group-hover:bg-white group-hover:scale-110">
                    <MapPinHouse className="w-5 h-5 transition-colors duration-200 group-hover:text-[#355931]" />
                  </div>
                  <p className="text-sm sm:text-base leading-relaxed text-white text-opacity-90 transition-all duration-200 group-hover:text-white">
                    Survey no. 1582, Swagat-3 Industrial Park, Ahmedabad-Indore Highway, Kuha, Ahm-382433, Gujarat, INDIA
                  </p>
                </a>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-white border-opacity-30 my-8"></div>

          {/* Bottom Section */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
            <p className="text-sm sm:text-base text-center sm:text-left text-white text-opacity-80">
              Copyright © 2025 Nutralike Health Care. All Rights Reserved.
            </p>
            
            {/* Social Icons */}
            <div className="flex items-center gap-6">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full border-2 border-white flex items-center justify-center transition-all duration-200 hover:bg-white hover:scale-110 group"
                  aria-label={social.name}
                >
                  <social.icon className="w-5 h-5 transition-colors duration-200 group-hover:text-[#355931]" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}